import { useStore } from "@/store";
import { Modal } from "@mantine/core";
import { SUPPORT_VIDEOS } from "@/configs/supportVideos";
import { useMemo } from "react";
import { SupportVideoPlayer } from "./SupportVideoPlayer";

export function SupportVideoModal() {
  const activeSupportVideoId = useStore(
    (state) => state.support.activeSupportVideoId,
  );

  const setActiveSupportVideoId = useStore(
    (state) => state.support.setActiveSupportVideoId,
  );

  const activeSupportVideo = useMemo(() => {
    if (!activeSupportVideoId) {
      return null;
    }

    return SUPPORT_VIDEOS[activeSupportVideoId as keyof typeof SUPPORT_VIDEOS];
  }, [activeSupportVideoId]);

  const closeModal = () => {
    setActiveSupportVideoId(null);
  };

  return (
    <Modal
      opened={!!activeSupportVideo}
      title={`${activeSupportVideo?.title}`}
      centered
      size="lg"
      onClose={closeModal}
    >
      <SupportVideoPlayer url={activeSupportVideo?.url || ""} />
    </Modal>
  );
}
